// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'babel-polyfill';

import ElementUI from 'element-ui';
import qs from 'qs'
import service from '@/utils/request'

import 'element-ui/lib/theme-chalk/index.css';
import "@/assets/font/iconfont.css"

import '@/assets/style/base.css'
import '@/assets/style/common.css'

// 引入公共组件
import ComHeader from './components/ComHeader.vue'
import ComFooter from './components/ComFooter.vue'

Vue.config.productionTip = false
Vue.prototype.$http = service
Vue.prototype.$qs = qs
Vue.use(ElementUI);

Vue.component('ComHeader', ComHeader)
Vue.component('ComFooter', ComFooter)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js